import React from 'react';
import classnames from 'classnames';
import { usePagination } from '../../common/utils/hooks/usePagination';
import './Pagination.scss';
import { connect } from "react-redux";
import { VENTILATOR_ADDITIONAL_FEATURES } from '../../common/ENUMS/PARAMETER_ENUM';

const Pagination = props => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    // If there are less than 2 times in pagination range we shall not render the component
    if (currentPage === 0 || paginationRange && paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange && paginationRange[paginationRange.length - 1];
    const hasCo2 = !!props?.ventilatorAdditionalFeaturesData?.find(
        f => f.id === VENTILATOR_ADDITIONAL_FEATURES?.capnography
    )?.on;

    const hasSpo2 = !!props?.ventilatorModuleConnectionStatus?.spo2;

    return (
        <ul
            className={classnames('pagination-container', { [className]: className })}
        >
            {paginationRange &&
                paginationRange.map(pageNumber => {

                    const isPage4Disabled =
                        pageNumber === 4 && !hasCo2 ;

                    return (
                        <li
                            key={pageNumber}
                            className={classnames('pagination-item', {
                                selected: pageNumber === currentPage,
                            })}
                            style={
                                isPage4Disabled
                                    ? { opacity: 0.4, cursor: 'not-allowed' }
                                    : {}
                            }
                            onClick={
                                isPage4Disabled
                                    ? undefined
                                    : () => onPageChange(pageNumber)
                            }
                        >
                            {pageNumber}
                        </li>
                    );
                })}
        </ul>
    );
};

const mapStateToProps = (state, ownProps) => {
    let ventilatorAdditionalFeaturesData =
        state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId] ?
            state?.deviceVitalDataReducer?.ventilatorAdditionalFeaturesData?.[ownProps.bedId]?.ventilatorAdditionalFeaturesData
            : [];
    let ventilatorModuleConnectionStatus =
        state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId] ?
            state?.deviceVitalDataReducer?.ventilatorModuleConnectionStatus?.[ownProps.bedId]?.ventilatorModuleConnectionStatus
            : [];

    return {

        ventilatorAdditionalFeaturesData: ventilatorAdditionalFeaturesData,
        ventilatorModuleConnectionStatus: ventilatorModuleConnectionStatus

    }
}

export default connect(mapStateToProps, null)(Pagination);

